export const FirebaseConfig = {
	"projectId": "taximovillucas",
	"appId": "1:329595537110:web:e4078faf6d9f9cecb9eb77",
	"databaseURL": "https://taximovillucas-default-rtdb.firebaseio.com",
	"storageBucket": "taximovillucas.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDonDsDfa_ick9At0RrSO35XOb0kuKSqLg",
	"authDomain": "taximovillucas.firebaseapp.com",
	"messagingSenderId": "329595537110",
	"measurementId": "G-JQPBLJTYZ0",
	"projectNumber": "329595537110",
	"version": "2"
};